import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useState } from "react";
import { useNavigation } from "react-router-dom";
import {
  getGarmentPack,
  getStoreGarmentCategoryServicesByPriceId,
} from "../../services/GarmentCategory/GarmentCategory";
import { editMoreItemToOrder, editMoreItemToOrderAdmin, editMoreItemToOrderB2B } from "../../services/Cart/addItemToCart";
import { Button } from "primereact/button";
import BookNewOrderModal from "./BookNewOrderModal";
import { getLocalGarmentPack, getUserData } from "../../utils/localStorage";

const B2BBottomSheetViewFormEdit = ({
  selectedGarment,
  onAddToCart,
  onClose,
  storeId,
  storeCustomerId,
  // selectedPriceId,
  BookingType,
  offerPriceEnabled,
  bookingOrderId,
  brandId,
  priceId,
  garmentCategoryServicePrice,
  garmentMaxProcessCount,
}) => {

  const selectedPriceId = priceId;
  const navigate = useNavigation();
  const [aliasValue, setAliasValue] = useState("");
  const [garmentRemarkValue, setGarmentRemarkValue] = useState("");
  const [packingTypeValue, setPackingTypeValue] = useState("");

  const { userProfileData, userProfileRole } = getUserData();
const storeUserId = userProfileData.id;
const userRole = userProfileRole;

  // New state variables for error messages
  const [aliasError, setAliasError] = useState("");
  const [garmentRemarkError, setGarmentRemarkError] = useState("");

  const [isGarmentViewDisable, setIsGarmentViewDisable] = useState(false);
  const [isGarmentButtonPressed, setIsGarmentButtonPressed] = useState(false);

  const [modalVisible, setModalVisible] = useState(false);
  const [packagingType, setPackagingType] = useState([]);
  const [servicesData, setServicesData] = useState([]);
  const [addonsArray, setAddonsArray] = useState([]);

  const [priceError, setPriceError] = useState("");
  const [priceChangeError, setPriceChangeError] = useState("");
  const [quantityError, setQuantityError] = useState("");
  const [handleInputDisable, setHandleInputDisable] = useState(false);
  const [garmentCountValue, setGarmentCountValue] = useState("");

  useEffect(() => {
    fetchAppService();
    // fetchGarmentPack();
    fetchLocalGarmentPack();
  }, []);

  const fetchLocalGarmentPack = async () => {
          const { garmentPack } = getLocalGarmentPack();
      if (garmentPack && Object.keys(garmentPack).length > 0) {
             
        setPackagingType(garmentPack);
          } else {
        setPackagingType([]);
          }
        };
  


  const fetchAppService = async () => {
    try {
      const response = await getStoreGarmentCategoryServicesByPriceId(
        storeId,
        storeCustomerId,
        selectedGarment.id,
        selectedPriceId
      );
      if (!response.data.error) {
        const modifiedServiceResponse = response.data.map((item, index) => ({
          ...item,
          isSelect: false,
        }));
        setServicesData(modifiedServiceResponse);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // const fetchGarmentPack = () => {
  //   getGarmentPack(brandId, storeId)
  //     .then((response) => {
  //       if (!response.data.error) {
  //         const Res = response.data.map((item, index) => ({
  //           name: item.name,
  //           value: item.name,
  //         }));
  //         setPackagingType(Res);
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Error:", err);
  //     });
  // };

  useEffect(() => {
    if (selectedGarment) {
      const {
        // garment: {name, code, description, qrCodeCount},
        // category: {name: categoryName},
        // id,
        garmentAlias,
        remarks,
        garmentPack,
        addOns,
        garmentQrCount,
        itemGarmentCount,
      } = selectedGarment;

      const garmentCountCal = itemGarmentCount / garmentQrCount;
      setGarmentCountValue(garmentCountCal);
      setAliasValue(garmentAlias);
      setGarmentRemarkValue(remarks);
      setPackingTypeValue(garmentPack);
      setAddonsArray(addOns);
      if (addOns.length > 1) {
        setHandleInputDisable(true);
      } else {
        setHandleInputDisable(false);
      }
    }
  }, [selectedGarment]);

  const handleAliasChange = (text) => {
    if(text === '' || /^[a-zA-Z\s]*$/.test(text)) {
      setAliasValue(text);
      setAliasError('')
    } else {
      setAliasError('Only alphabets allowed');
    }
  };

  const handleGarmentRemarkChange = (text) => {
    setGarmentRemarkValue(text);
  };
  const [focusedField, setFocusedField] = useState("");

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField("");
  };

  const [focusedDropdown, setFocusedDropdown] = useState("");

  const handleDropdownFocus = (field) => {
    setFocusedDropdown(field);
  };

  const handleDropdownBlur = () => {
    setFocusedDropdown("");
  };

  const [addOns, setAddOns] = useState(selectedGarment.addOns);

  const handlePriceChange = (text, addOnId) => {
    const newPriceValue = parseFloat(text);

    setAddOns((prevAddOns) =>
      prevAddOns.map((addOn) => {
        if (addOn.id === addOnId) {
          let priceListId = addOn.priceListId;

          let newData = garmentCategoryServicePrice?.filter(
            (item) => item.id === priceListId
          );

          const minAmount = newData[0]?.brandAppService.minAmount;
          const maxAmount = newData[0]?.brandAppService.maxAmount;

          if (
            isNaN(newPriceValue) ||
            newPriceValue < minAmount ||
            newPriceValue > maxAmount
          ) {
            // Handle case where price is not a valid number or out of range
            setPriceError(
              `Price must be between ${minAmount} and ${maxAmount}`
            );
            return {
              ...addOn,
              offerPrice: null,
              totalPrice: 0,
            };
          } else {
            let totalCount = addOn.count + addOn.countGram;
            const updatedCount = totalCount; // Default to 1 if count is not set
            const updatedTotalPrice = Math.round(newPriceValue * updatedCount);
            setPriceError("");
            return {
              ...addOn,
              offerPrice: newPriceValue,
              totalPrice: updatedTotalPrice,
            };
          }
        }
        return addOn;
      })
    );
  };

  const handleGarmentItemChange = (text, addOnId) => {
    const newAddOnQrCountValue = parseFloat(text);
    setAddOns((prevAddOns) => {
      return prevAddOns.map((addOn) => {
        if (addOn.id === addOnId) {
          if (isNaN(newAddOnQrCountValue) || newAddOnQrCountValue <= 0) {
            setQuantityError("Garment Count Can Not Be Empty Or Zero");
            setGarmentCountValue(0);
            return {
              ...addOn,
              addOnQrCount: null,
            };
          } else if(newAddOnQrCountValue > garmentMaxProcessCount) {
            setQuantityError("Garment Count Can Not Be " + garmentMaxProcessCount);
            setGarmentCountValue(0);
            return {
              ...addOn,
              addOnQrCount: null,
            };
          } else {
            let addOnQrCount = addOn.addOnQrCount;

            addOnQrCount =
              newAddOnQrCountValue * selectedGarment.garmentQrCount;
            setGarmentCountValue(newAddOnQrCountValue);
            setQuantityError(""); // Clear the error if the count is valid
            return {
              ...addOn,
              addOnQrCount: addOnQrCount,
            };
          }
        }
        return addOn;
      });
    });
  };

  const [inputValues, setInputValues] = useState({});

  const handleCountChange = (text, addOnId) => {
    setInputValues((prevInputValues) => ({
      ...prevInputValues,
      [addOnId]: text, // Update the raw input value for the specific addOn
    }));

    if (text === "" || text == 0) {
      // Handle clearing the input field
      setAddOns((prevAddOns) => {
        return prevAddOns.map((addOn) => {
          if (addOn.id === addOnId) {
            return {
              ...addOn,
              count: "",
              countGram: "",
              totalPrice: 0,
            };
          }
          return addOn;
        });
      });
      setQuantityError("Quantity cannot be empty or zero");
      setIsGarmentButtonPressed(true);
    } else if(text > garmentMaxProcessCount) {
      setAddOns((prevAddOns) => {
        return prevAddOns.map((addOn) => {
          if (addOn.id === addOnId) {
            return {
              ...addOn,
              count: "",
              countGram: "",
              totalPrice: 0,
            };
          }
          return addOn;
        });
      });
      setQuantityError("Quantity cannot be Greater than " + garmentMaxProcessCount);
      setIsGarmentButtonPressed(true);
    } else {
      const newCountValue = parseFloat(text);
      if (!isNaN(newCountValue)) {
        // Calculate the count (integer part) and countGram (decimal part)
        const updatedCount = Math.floor(newCountValue); // Integer part
        const updatedCountGram = parseFloat(
          (newCountValue - updatedCount).toFixed(2) // Decimal part, rounded to 2 decimals
        );

        setAddOns((prevAddOns) => {
          return prevAddOns.map((addOn) => {
            if (addOn.id === addOnId) {
              const updatedPrice = addOn.offerPrice || 0; // Default to 0 if price is not set
              let addOnQrCount = addOn.addOnQrCount;

              if (addOn.serviceUnit === "Qty") {
                addOnQrCount = updatedCount * selectedGarment.garmentQrCount;
              }

              const updatedTotalPrice = Math.round(
                updatedPrice * newCountValue // Price multiplied by full value (int + decimal)
              );

              return {
                ...addOn,
                addOnQrCount: addOnQrCount,
                count: updatedCount,
                countGram: updatedCountGram,
                totalPrice: updatedTotalPrice,
              };
            }
            return addOn;
          });
        });

        setQuantityError(""); // Clear the error if the input is valid
        setIsGarmentButtonPressed(false);
      } else {
        setQuantityError("Please enter a valid quantity");
        setIsGarmentButtonPressed(true);
      }
    }
  };

  const incrementCount = (addOnId) => {
    setAddOns((prevAddOns) =>
      prevAddOns.map((addOn) => {
        if (addOn.id === addOnId) {
          let totalCount = addOn.count + addOn.countGram;
          const countValue =
            addOn.serviceUnit === "Qty" ? totalCount + 1 : totalCount + 0.1;

            if(countValue > garmentMaxProcessCount) {
              return addOn;
            }

          const updatedPrice = addOn.offerPrice;
          // const updatedTotalPrice = updatedPrice * countValue;
          const updatedCount = Math.floor(countValue);
          const updatedCountGram = parseFloat(
            (countValue - updatedCount).toFixed(2)
          );
          let addOnQrCount = addOn.addOnQrCount;
          if (addOn.serviceUnit === "Qty") {
            addOnQrCount = updatedCount * selectedGarment.garmentQrCount;
          }
          const updatedTotalPrice = Math.round(updatedPrice * countValue);
          return {
            ...addOn,
            addOnQrCount: addOnQrCount,
            count: updatedCount,
            countGram: updatedCountGram,
            totalPrice: updatedTotalPrice,
          };
        }
        return addOn;
      })
    );
  };

  const decrementCount = (addOnId) => {
    setAddOns((prevAddOns) =>
      prevAddOns.map((addOn) => {
        let totalCount = addOn.count + addOn.countGram;
        if (addOn.id === addOnId && totalCount > 1) {
          const countValue =
            addOn.serviceUnit === "Qty" ? totalCount - 1 : totalCount - 0.1;

          const updatedPrice = addOn.offerPrice;
          const updatedCount = Math.floor(countValue);
          const updatedCountGram = parseFloat(
            (countValue - updatedCount).toFixed(2)
          );
          let addOnQrCount = addOn.addOnQrCount;
          if (addOn.serviceUnit === "Qty") {
            addOnQrCount = updatedCount * selectedGarment.garmentQrCount;
          }
          const updatedTotalPrice = Math.round(updatedPrice * countValue);
          return {
            ...addOn,
            addOnQrCount: addOnQrCount,
            count: updatedCount,
            countGram: updatedCountGram,
            totalPrice: updatedTotalPrice,
          };
        }
        return addOn;
      })
    );
  };

  useEffect(() => {
    if (modalVisible) {
      // Set a timeout to close the modal after 2000 milliseconds (2 seconds)
      const timeoutId = setTimeout(() => {
        onClose(); // Call the onClose callback
        setModalVisible(false); // Close the modal by updating state
      }, 500);

      // Clear the timeout if the component unmounts or modalVisible changes
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [modalVisible, onClose]);

  const handleEditGarment = (event) => {
    // Check if the button has already been pressed

    event.preventDefault();
    let isValid = true;

    if (addOns.some((addOn) => addOn.offerPrice === null)) {
      setPriceError("Price can not be empty or zero");
      isValid = false;
    }
    if (addOns.some((addOn) => addOn.count === null)) {
      setQuantityError("Quantity can not be empty or zero");
      isValid = false;
    }

    if (!isValid) {
      return;
    }

    if (!isGarmentButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsGarmentButtonPressed(true);
      setIsGarmentViewDisable(true);
      const updateGarment = {
        ...selectedGarment,
        addOns: addOns,
        remarks: garmentRemarkValue,
        garmentPack: packingTypeValue,
        garmentAlias: aliasValue?.toUpperCase(),
        itemGarmentCount:
          selectedGarment.garmentQrCount *
          (handleInputDisable
            ? 1
            : addOns[0].serviceUnit === "Qty"
            ? addOns[0].count
            : garmentCountValue),
        editBy:storeUserId,
        editByUserName: userProfileData?.firstName + userProfileData?.lastName
      };

      userRole === "BY_STORE"
        ? editMoreItemToOrderB2B(
            storeCustomerId,
            storeId,
            bookingOrderId,
            updateGarment
          )
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                // Call the onAddToCart callback to add the garment to the cart
                setModalVisible(true);
                setIsGarmentButtonPressed(false);
                setIsGarmentViewDisable(false);
                if (Res) {
                  navigate("/B2BOrdersGarmentInfo", {
                    state: {
                      bookingOrderId: bookingOrderId,
                      storeCustomerId: storeCustomerId,
                    },
                  });
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            })
        : editMoreItemToOrderB2B(
            storeCustomerId,
            storeId,
            bookingOrderId,
            updateGarment
          )
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                // Call the onAddToCart callback to add the garment to the cart
                setModalVisible(true);
                setIsGarmentButtonPressed(false);
                setIsGarmentViewDisable(false);
                if (Res) {
                  navigate("/B2BOrdersGarmentInfo", {
                    state: {
                      bookingOrderId: bookingOrderId,
                      storeCustomerId: storeCustomerId,
                    },
                  });
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            }); 
      
    }
  };

  const renderAddOnItem = () => {
    return addOns?.map((item, index) => {
      // const totalPrice = item.offerPrice * item.count;
      const totalCount = item.count + item.countGram;

      return (
        <div className="mb-4">
          <div className="flex flex-row gap-3">
            <div
              className="ml-1 py-1 flex-1"
              style={{
                backgroundColor: "#6EA4F5",
                borderRadius: 5,
              }}
            >
              <div className="ml-4">
                <p className="text-xl font-bold text-white">
                  {item.serviceName} {item.totalPrice}
                </p>
              </div>
            </div>
          </div>
          <div>
            <div className="flex flex-row">
              <div className="flex-1 mx-2 my-1">
                <div>
                  <p>Price</p>
                  <div className="border-round-xl shadow-2">
                    <InputText
                      style={{ width: "100%" }}
                      value={item?.offerPrice?.toString()}
                      onChange={(e) => {
                        handlePriceChange(e.target.value, item.id);
                        setPriceChangeError(
                          "If the price changes, all offers will be removed."
                        );
                      }}
                      keyboardType="numeric"
                      disabled={!offerPriceEnabled ? true : false}
                    />
                  </div>
                </div>
              </div>
              <div className="flex-1 mx-2 my-1">
                {userRole === "BY_STORE" ? (
                  <div className="flex flex-row justify-content-center align-items-center">
                    {item.serviceUnit === "Qty" && (
                      <div
                        onClick={() => {
                          if (
                            !handleInputDisable ||
                            item.serviceUnit !== "Qty"
                          ) {
                            decrementCount(item.id);
                            setPriceChangeError(
                              "If the unit changes, all offers will be removed."
                            );
                          }
                        }}
                        role="button"
                        className={`justify-content-center align-items-center shadow-4 mx-2 mt-4 cursor-pointer ${
                          handleInputDisable && item.serviceUnit === "Qty"
                            ? "disabled"
                            : ""
                        }`}
                        style={{
                          backgroundColor:
                            handleInputDisable && item.serviceUnit === "Qty"
                              ? "#A9A9A9"
                              : "#2B70D7",
                          borderRadius: "50%", // Ensure circular shape
                          width: 30,
                          height: 30,
                          opacity:
                            handleInputDisable && item.serviceUnit === "Qty"
                              ? 0.6
                              : 1,
                          pointerEvents:
                            handleInputDisable && item.serviceUnit === "Qty"
                              ? "none"
                              : "auto",
                        }}
                      >
                        <p className="text-xl font-bold text-white text-center">
                          -
                        </p>
                      </div>
                    )}

                    <div>
                      <p>{item.serviceUnit}</p>
                      <div className="border-round-xl shadow-2">
                        <InputText
                          value={
                            totalCount?.toString()
                              ? totalCount?.toString()
                              : inputValues[item.id]
                          } // Display the current input value
                          onChange={(e) => {
                            handleCountChange(e.target.value, item.id);
                            setPriceChangeError(
                              "If the unit changes, all offers will be removed."
                            );
                          }}
                          disabled={
                            handleInputDisable && item.serviceUnit === "Qty"
                              ? true
                              : false
                          }
                          keyboardType="numeric"
                        />
                      </div>
                    </div>

                    {item.serviceUnit === "Qty" && (
                      <div
                        onClick={() => {
                          if (
                            !handleInputDisable ||
                            item.serviceUnit !== "Qty"
                          ) {
                            incrementCount(item.id);
                            setPriceChangeError(
                              "If the unit changes, all offers will be removed."
                            );
                          }
                        }}
                        className={`justify-content-center align-items-center shadow-4 mx-2 mt-4 cursor-pointer ${
                          handleInputDisable && item.serviceUnit === "Qty"
                            ? "disabled"
                            : ""
                        }`}
                        style={{
                          backgroundColor:
                            handleInputDisable && item.serviceUnit === "Qty"
                              ? "#A9A9A9"
                              : "#2B70D7",
                          borderRadius: "50%", // Ensure circular shape
                          width: 30,
                          height: 30,
                          opacity:
                            handleInputDisable && item.serviceUnit === "Qty"
                              ? 0.6
                              : 1,
                          pointerEvents:
                            handleInputDisable && item.serviceUnit === "Qty"
                              ? "none"
                              : "auto",
                        }}
                      >
                        <p className="text-xl font-bold text-white text-center">
                          +
                        </p>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="flex flex-row justify-content-center align-items-center">
                     

                    <div>
                      <p>{item.serviceUnit}</p>
                      <div className="border-round-xl shadow-2">
                        <InputText
                          value={
                            totalCount?.toString()
                              ? totalCount?.toString()
                              : inputValues[item.id]
                          } // Display the current input value
                          onChange={(e) => {
                            handleCountChange(e.target.value, item.id);
                            setPriceChangeError(
                              "If the unit changes, all offers will be removed."
                            );
                          }}
                          disabled={
                            true
                          }
                          keyboardType="numeric"
                        />
                      </div>
                    </div>

                     
                  </div>
                )}
              </div>
            </div>
            {userRole === "BY_STORE" && ["Mtr", "SqFt", "Kg"].includes(item.serviceUnit) && (
              <div className="flex flex-row">
                <div className="flex-1 mx-2 my-1">
                  <div>
                    <p>Garment Count</p>
                    <div className="border-round-xl shadow-2">
                      <InputText
                        style={{ width: "100%" }}
                        value={garmentCountValue?.toString()}
                        onChange={(e) => {
                          handleGarmentItemChange(e.target.value, item.id);
                          setPriceChangeError(
                            "If the count changes, all offers will be removed."
                          );
                        }}
                        editable={!handleInputDisable}
                        keyboardType="numeric"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    });
  };

  return (
    <div>
      <div>
      {garmentCategoryServicePrice.length > 0 ? 
        <div style={{ pointerEvents: isGarmentViewDisable ? "none" : "auto" }}>
          <div style={{ marginTop: 10 }}>
            {renderAddOnItem()}
            {priceError !== "" && (
              <p className="text-md font-normal" style={{ color: "red" }}>
                {priceError}
              </p>
            )}
            {quantityError !== "" && (
              <p className="text-md font-normal" style={{ color: "red" }}>
                {quantityError}
              </p>
            )}
          </div>

          <div className="flex-1 mx-2 mb-1 mt-3">
            <div className="border-round-xl shadow-2">
              <InputText
                style={{ width: "100%" }}
                id="Alias"
                value={aliasValue}
                onChange={(e) => handleAliasChange(e.target.value)}
                placeholder="Alias"
              />
            </div>
          </div>
          {aliasError !== "" && (
            <p className="text-md font-normal" style={{ color: "red" }}>
              {aliasError}
            </p>
          )}

          {/* Third row with input field */}

          <div className="flex-1 mx-2 mb-1 mt-3">
            <div className="border-round-xl shadow-2">
              <Dropdown
                value={packingTypeValue}
                onChange={(e) => setPackingTypeValue(e.value)}
                options={packagingType}
                optionLabel="name"
                placeholder="Packing Type"
                className="w-full  bg-white-alpha-20  text-2xl text-primary-50"
              />
            </div>
          </div>

          <div className="flex-1 mx-2 mb-1 mt-3">
            <div className="border-round-xl shadow-2">
              <InputText
                style={{ width: "100%" }}
                id="GarmentRemark"
                value={garmentRemarkValue}
                placeholder="Garment Remark"
                onChange={(e) => handleGarmentRemarkChange(e.target.value)}
              />
            </div>
          </div>
          <div className="flex-1 mx-2 mb-1 mt-3">
            <div className=" flex justify-content-center">
              <Button
                label="Update"
                onClick={handleEditGarment}
                disabled={isGarmentButtonPressed}
                className=" text-2xl w-full border-round-xl border-none cursor-pointer"
              ></Button>
            </div>
          </div>

          {priceChangeError !== "" && (
            <p className="text-md font-normal" style={{ color: "red" }}>
              Note * {priceChangeError}
            </p>
          )}
        </div> 
        : <div className="flex justify-content-center">
          <p className="text-md font-normal">Please Wait Loading...</p>
        </div>
      }
        <BookNewOrderModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          onClose={onClose}
          messageType={"edit"}
        />
      </div>
    </div>
  );
};

export default B2BBottomSheetViewFormEdit;
